import {ConfirmationDialog} from "./ConfirmationDialog/ConfirmationDialog";
import * as React from "react";
import {WpAjaxPost} from "../../../utilities/ajax/WPAjaxPost";

export class DeleteDialog{
    public static async Show(itemName:string,title:string='Are you sure?',applyCallBack:()=>Promise<boolean>=null){
        return new Promise(resolve=>{
            let dialog=ConfirmationDialog.Create(title,
                <React.Fragment>
                                <p>Are you sure you want to delete <strong
                            style={{color: 'red'}}>{itemName}</strong></p>
                        </React.Fragment>)
                            .UseDeleteIcon()
                .SetApplyText('Yes, delete');

            if(applyCallBack!=null)
                dialog.OnApply(applyCallBack);
                    dialog.Show();
        });
    }
}